import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getNodeByKey } from "lexical";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
import { $isVariableNode } from "./variable-node";
/** Renders a template variable: an editable populated value with a label tooltip, or an unfilled `[label]`. */
export function VariableComponent(_ref) {
  var label = _ref.label,
    value = _ref.value,
    nodeKey = _ref.nodeKey;
  var _useLexicalComposerCo = useLexicalComposerContext(),
    _useLexicalComposerCo2 = _slicedToArray(_useLexicalComposerCo, 1),
    editor = _useLexicalComposerCo2[0];
  var _useState = useState(editor.isEditable()),
    editable = _useState[0],
    setEditable = _useState[1];
  var spanRef = useRef(null);
  var focused = useRef(false);
  var _useState2 = useState(null),
    tooltip = _useState2[0],
    setTooltip = _useState2[1];
  useEffect(function () {
    return editor.registerEditableListener(setEditable);
  }, [editor]);
  useLayoutEffect(function () {
    if (spanRef.current && !focused.current) spanRef.current.textContent = value !== null && value !== void 0 ? value : "";
  }, [value, editable]);
  var syncValue = useCallback(function (text) {
    editor.update(function () {
      var node = $getNodeByKey(nodeKey);
      if ($isVariableNode(node)) node.setValue(text || undefined);
    });
  }, [editor, nodeKey]);
  var showTooltip = useCallback(function () {
    var _spanRef$current;
    if (focused.current) return;
    var rect = (_spanRef$current = spanRef.current) === null || _spanRef$current === void 0 ? void 0 : _spanRef$current.getBoundingClientRect();
    if (rect) setTooltip({
      top: rect.top,
      left: rect.left + rect.width / 2
    });
  }, []);
  if (!editable) return /*#__PURE__*/React.createElement("span", null, value !== null && value !== void 0 ? value : "[".concat(label, "]"));
  if (value === undefined) {
    return /*#__PURE__*/React.createElement("span", {
      className: "text-yellow-500 dark:text-yellow-400"
    }, "[", label, "]");
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    ref: spanRef,
    contentEditable: true,
    suppressContentEditableWarning: true,
    "data-testid": "letter-variable-".concat(label),
    className: "cursor-text border-b border-current outline-none",
    onFocus: function onFocus() {
      focused.current = true;
      setTooltip(null);
    },
    onKeyDown: function onKeyDown(event) {
      return event.stopPropagation();
    },
    onInput: function onInput(event) {
      event.stopPropagation();
      if (!event.currentTarget.textContent) {
        focused.current = false;
        syncValue("");
      }
    },
    onBlur: function onBlur(event) {
      var _event$currentTarget$, _event$currentTarget$2;
      trackEvent(ANALYTICS_EVENTS.LETTER_VARIABLE, {
        label: label
      });
      focused.current = false;
      syncValue((_event$currentTarget$ = (_event$currentTarget$2 = event.currentTarget.textContent) === null || _event$currentTarget$2 === void 0 ? void 0 : _event$currentTarget$2.trim()) !== null && _event$currentTarget$ !== void 0 ? _event$currentTarget$ : "");
    },
    onMouseEnter: showTooltip,
    onMouseLeave: function onMouseLeave() {
      return setTooltip(null);
    }
  }), tooltip ? /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement("div", {
    className: "pointer-events-none fixed z-sds-1200 flex -translate-x-1/2 -translate-y-full flex-col items-center",
    style: {
      top: tooltip.top - 8,
      left: tooltip.left
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "whitespace-nowrap rounded-sds-200 bg-gray-900 px-2.5 py-1.5 text-style-label-strong text-white shadow-sds-400 dark:bg-gray-700"
  }, label)), document.body) : null);
}